
/*
 * LA FERME ANGEL
 * Affichage conditionnel d'une option Globo
 *
 * Masque "Je veux mes médailles" tant qu'aucune
 * médaille n'est sélectionnée.
 */

(() => {

  // ==========================================
  // 1. LISTE DES PRODUITS CONCERNÉS
  // ==========================================

  // Ajouter ici les handles Shopify des produits.
  // Le handle est la partie de l'URL après /products/

  const PRODUITS = new Set([
    'amulettes-numen-chaine-4',
    'base-cordon-numen™',
    'base-bracelet-torsade-ronde',
    'base-bracelet-vintage-barette',
    'amulettes-numen-chaine-noeuds-agrafe-copie',
    'base-chaine-boheme',
    'amulettes-numen-chaine-1',
    'base-chaine-gourmette',
    'amulettes-numen-chaine-copie',
    'base-chaine-mini-serpentine',
    'amulettes-numen-chaine-5',
    'amulettes-numen-chaine',
    'amulettes-numen-chaine-2',
    'amulettes-numen-chaine-3',
    'amulettes-numen-chaine-4',
    'amulettes-numen-boheme-lolite',
    'amulettes-numen-boheme-agathe-raye',
    'amulettes-numen-boheme-aigues-marine-1',
    'amulettes-numen-boheme-amethyste',
    'amulettes-numen-boheme-apatite-bleu',
    'amulettes-numen-boheme-apatite-bleu-1',
    'amulettes-numen-boheme-hematite',
    'amulettes-numen-boheme-larimar',
    'amulettes-numen-boheme-magnesite',
    'amulettes-numen-boheme-morganite',
    'amulettes-numen-boheme-perles',
    'amulettes-de-chance-boheme-quartzite',
    'amulettes-numen-boheme-rubis',
    'amulettes-numen-boheme-tourmaline-elbaite',
    'amulettes-numen-boheme-tourmaline-elbaite-1',
    'la-base-cordon-angel-wool™',
    'la-base-cordon-stardust™',
    'la-base™-pierres-naturelles',
    'la-base-pierres-naturelles-goldstone™',
    'base-bracelet-gourmette',
    'la-base-cordon-stardust™',
    'le-grigri-de-charlotte-the-nomad',
    'collier-amulette-bandanna-5',
    'la-chaine-de-sac-1',
    'la-chaine-de-sac-triple',
    'bracelet-numen-lien-cordon-1',
    'bracelet-numen-lien-cordon-2',
    'bracelet-numen-lien-cordon-3',
    'bracelet-numen-lien-cordon-4',
    'bracelet-numen-lien-cordon-5',
    'bracelet-numen-lien-cordon-6',
    'bracelet-numen-lien-cordon-7',
    'bracelet-numen-lien-cordon-8',
    'bracelet-numen-lien-cordon-9',
    'bracelet-numen-lien-cordon-10',
    'bracelet-numen-lien-cordon-11',
    'bracelet-numen-lien-cordon-12',
    'bracelet-numen-lien-cordon-13',
    'bracelet-numen-lien-cordon-14',
    'bracelet-numen-lien-cordon-15',
    'bracelet-numen-lien-cordon-16',
    'bracelet-numen-lien-cordon-17',
    'bracelet-numen-lien-cordon-18',
    'bracelet-numen-lien-cordon-19',
    'bracelet-numen-lien-cordon-20',
    'bracelet-numen-lien-cordon-21',
    'bracelet-numen-lien-cordon-22',
    'bracelet-numen-lien-cordon-23',
    'bracelet-numen-lien-cordon-24',
    'bracelet-numen-lien-cordon-25',
    'bracelet-numen-lien-cordon-26',
    'bracelet-numen-lien-cordon-27',
    'bracelet-numen-lien-cordon-28',
    'bracelets-de-chance-lapis-azulis-citrine-apatite-pierre-de-lune-amethyste-aigues-marine-sodalite-bleu',
    'bracelet-numen-lien-marron',
    'bracelets-numen-lien-boheme-tourmaline-elbaite-1',
    'bracelets-numen-lien-boheme-tourmaline-elbaite',
    'bracelets-numen-lien-boheme-rubis',
    'bracelets-numen-lien-boheme-quartzite',
    'bracelets-numen-lien-boheme-perles',
    'bracelets-numen-lien-boheme-morganite',
    'bracelets-numen-lien-boheme-magnesite',
    'bracelet-numen-lien-oeil-de-tigre-copie',
    'bracelets-numen-lien-boheme-larimar',
    'bracelets-numen-lien-boheme-hematite',
    'bracelets-numen-lien-boheme-apatite-bleu-1',
    'bracelets-numen-lien-boheme-apatite-bleu',
    'bracelets-numen-lien-boheme-amethyste',
    'bracelets-numen-lien-boheme-aigues-marine',
    'bracelets-numen-lien-boheme-agathe-raye',
    'les-bijoux-de-chaussures',
    'amulettes-numen-cordon-6-perles',
    'amulettes-numen-cordon-6-perles-1',
    'amulettes-numen-cordon-6-perles-2',
    'amulettes-numen-cordon-6-perles-3',
    'amulettes-numen-cordon-6-perles-4',
    'amulettes-numen-cordon-6-perles-5',
    'amulettes-numen-cordon-6-perles-6',
    'amulettes-numen-cordon-6-perles-7',
    'amulettes-numen-cordon-6-perles-8',
    'amulettes-numen-cordon-6-perles-9',
    'amulettes-numen-cordon-6-perles-10',
    'amulettes-numen-cordon-6-perles-11',
    'amulettes-numen-cordon-6-perles-12',
    'amulettes-numen-cordon-6-perles-13',
    'amulettes-numen-cordon-6-perles-14',
    'amulettes-numen-cordon-6-perles-15',
    'amulettes-numen-cordon-6-perles-16',
    'amulettes-numen-cordon-6-perles-17',
    'amulettes-numen-cordon-6-perles-18',
    'amulettes-numen-cordon-6-perles-19',
    'amulettes-numen-cordon-6-perles-20',
    'amulettes-numen-cordon-6-perles-22',
    'amulettes-numen-cordon-6-perles-23',
    'amulettes-numen-cordon-6-perles-24',
    'amulettes-numen-cordon-6-perles-25',
    'amulettes-numen-cordon-6-perles-26',
    'amulette-angel-n-1',
    'amulette-angel-n-2',
    'amulette-angel-n-3',
    'amulette-angel-n-4',
    'amulette-angel-n-5',
    'amulette-angel-n-6',
    'amulette-angel-n-7',
    'amulette-angel-n-8',
    'amulette-angel-n-9',
    'amulette-angel-n-10',
    'amulette-angel-n-11',
    'amulette-angel-n-12',
    'amulette-angel-n-13',
    'amulette-angel-n-14',
    'amulette-angel-n-15',
    'amulette-angel-n-16',
    'amulette-angel-n-17',
    'amulette-angel-n-18',
    'amulette-angel-n-19',
    'amulette-angel-n-20',
    'amulette-angel-n-21',
    'amulette-angel-n-22',
    'amulette-angel-n-23',
    'amulette-angel-n-24',
    'amulette-angel-n-25',
    'amulette-angel-n-26',
    'amulette-angel-n-27',
    'amulette-angel-n-28',
    'amulette-angel-n-29',
    'amulette-angel-n-30',
    'amulette-angel-n-31',
    'amulette-angel-n-32',
    'amulette-angel-n-33',
    'amulette-angel-n-34',
    'amulette-angel-n-35',
    'amulette-angel-n-36',
    'amulette-angel-n-37',
    'amulette-angel-n-38',
    'amulette-angel-n-39',
    'amulette-angel-n-40',
    'amulette-angel-n-41',
    'amulette-angel-n-42',
    'amulette-angel-n-43',
    'amulette-angel-n-44',
    'amulette-angel-n-45',
    'amulette-angel-n-46',
    'amulette-angel-n-47',
    'amulette-angel-n-48',
    'amulette-angel-n-49',
    'amulette-angel-n-50',
    'amulette-angel-n-51',
    'amulette-angel-n-52',
    'amulette-angel-n-53',
    'amulette-angel-n-54',
    'amulette-angel-n-55',
    'amulette-angel-n-56',
    'amulette-angel-n-57',
    'amulette-angel-n-58',
    'amulette-angel-n-59',
    'amulette-angel-n-60',
    'amulette-angel-n-61',
    'amulette-angel-n-62',
    'amulette-angel-n-63',
    'amulette-angel-n-64',
    'amulette-angel-n-65',
    'amulette-angel-n-66',
    'amulette-angel-n-67',
    'amulette-angel-n-68',
    'amulette-angel-n-69',
    'amulette-angel-n-70',
    'amulette-angel-n-71',
    'amulette-angel-n-72',
    'amulette-angel-n-73',
    'amulette-angel-n-74',
    'amulette-angel-n-75',
    'amulette-angel-n-76',
    'amulette-angel-n-77',
    'amulette-angel-n-78',
    'amulette-angel-n-79',
    'amulette-angel-n-80',
    'amulette-angel-n-81',
    'amulette-angel-n-82',
    'amulette-angel-n-83',
    'amulette-angel-n-84',
    'amulette-angel-n-85'

  ]);

  // Vérification du produit actuel
  const match = window.location.pathname.match(
    /\/products\/([^/?#]+)/
  );

  if (
    !match ||
    !PRODUITS.has(
      decodeURIComponent(match[1]).toLowerCase()
    )
  ) {
    return;
  }


  // ==========================================
  // 2. NORMALISATION DES TEXTES
  // ==========================================

  const normalize = (text) =>
    String(text || '')
      .toLowerCase()
      .replace(/œ/g, 'oe')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();


  // ==========================================
  // 3. BLOC À MASQUER
  // ==========================================

  const TARGET = /^je veux mes medailles\b/;


  // ==========================================
  // 4. CATÉGORIES DE MÉDAILLES
  // ==========================================

  const CATEGORIES = [
    /^medailles? croix\b/,
    /^medailles? vierges?\b/,
    /^medailles? saint benoit\b/,
    /^medailles? coeurs?\b/,
    /^medailles? porte bonheur\b/,

    //médaille animal
    /^choix de medailles?\b/,
  ];


  // ==========================================
  // 5. CLASSE CSS POUR MASQUER LE BLOC
  // ==========================================

  const CSS_CLASS = 'angel-medailles-masquees';

  const style = document.createElement('style');

  style.textContent = `
    .gpo-app .${CSS_CLASS} {
      display: none !important;
    }
  `;

  document.head.appendChild(style);


  // ==========================================
  // 6. SÉLECTEURS GLOBO
  // ==========================================

  const LABEL_SELECTOR = [
    '.gpo-label',
    '.gpo-title',
    '.gpo-element-title',
    '.gpo-heading',
    'legend',
    'h2',
    'h3',
    'h4'
  ].join(', ');

  const CONTROL_SELECTOR = [
    'input[type="checkbox"]',
    'input[type="radio"]',
    'input[type="number"]',
    'select',
    '[role="checkbox"]',
    '[role="radio"]'
  ].join(', ');


  // ==========================================
  // 7. IDENTIFIER UNE CATÉGORIE
  // ==========================================

  function isCategory(name) {
    return CATEGORIES.some((pattern) =>
      pattern.test(name)
    );
  }


  // ==========================================
  // 8. IDENTIFIER LE TITRE D'UN BLOC GLOBO
  // ==========================================

  function blockTitle(block) {

    const labels = [
      ...block.querySelectorAll(LABEL_SELECTOR)
    ].filter((el) =>
      el.closest('.gpo-element') === block
    );

    for (const el of labels) {

      const text = normalize(el.textContent);

      if (
        TARGET.test(text) ||
        isCategory(text)
      ) {
        return text;
      }
    }

    return normalize(block.textContent).slice(0, 120);
  }


  // ==========================================
  // 9. DÉTECTER UNE MÉDAILLE SÉLECTIONNÉE
  // ==========================================

  function hasSelection(scope) {

    // Cases à cocher et boutons radio
    const checks = [
      ...scope.querySelectorAll(
        'input[type="checkbox"], ' +
        'input[type="radio"], ' +
        '[role="checkbox"], ' +
        '[role="radio"]'
      )
    ];

    const checked = checks.some((el) => {

      if (
        !(
          el.checked ||
          el.getAttribute('aria-checked') === 'true'
        )
      ) {
        return false;
      }

      const option = el.closest(
        'label, .gpo-choice, .gpo-option, .gpo-swatch'
      );

      const text = normalize(
        option ? option.textContent : ''
      );

      // Ignorer les options "Aucune médaille"
      return !/^(aucune?|sans medaille|je n en veux pas|non)\b/
        .test(text);
    });

    if (checked) {
      return true;
    }


    // Menus déroulants Globo
    const selectedList = [
      ...scope.querySelectorAll('select')
    ].some((select) => {

      const option = select.selectedOptions[0];

      return (
        option &&
        select.value !== '' &&
        select.value !== '0' &&
        !/^(choisir|selectionner|aucune?|sans medaille)\b/
          .test(normalize(option.textContent))
      );
    });

    if (selectedList) {
      return true;
    }


    // Champs de quantité
    if (!checks.length) {

      const positiveQty = [
        ...scope.querySelectorAll(
          'input[type="number"]'
        )
      ].some((input) =>
        Number(input.value) > 0
      );

      if (positiveQty) {
        return true;
      }
    }


    // Vignettes Globo sélectionnées
    return !!scope.querySelector(
      '.gpo-swatch.gpo-selected, ' +
      '.gpo-swatch.selected, ' +
      '.gpo-option.gpo-selected'
    );
  }


  // ==========================================
  // 10. METTRE À JOUR L'AFFICHAGE
  // ==========================================

  function update() {

    document.querySelectorAll('.gpo-app')
      .forEach((app) => {

        // Récupérer les blocs Globo
        const blocks = [
          ...app.querySelectorAll('.gpo-element')
        ].filter((el) =>
          !el.parentElement.closest('.gpo-element')
        );

        const names = blocks.map(blockTitle);

        // Rechercher "Je veux mes médailles"
        const targetIndex = names.findIndex(
          (name) => TARGET.test(name)
        );

        if (targetIndex === -1) {
          return;
        }

        let aUneMedaille = false;


        // Examiner les cinq catégories
        for (
          let i = 0;
          i < blocks.length && !aUneMedaille;
          i++
        ) {

          if (!isCategory(names[i])) {
            continue;
          }


          // Sélections dans le bloc lui-même
          if (
            blocks[i].querySelector(
              CONTROL_SELECTOR
            )
          ) {

            aUneMedaille = hasSelection(
              blocks[i]
            );

            continue;
          }


          // Sélections dans les blocs suivants
          // lorsque la catégorie est un titre
          for (
            let j = i + 1;
            j < blocks.length;
            j++
          ) {

            if (
              isCategory(names[j]) ||
              TARGET.test(names[j])
            ) {
              break;
            }

            if (hasSelection(blocks[j])) {
              aUneMedaille = true;
              break;
            }
          }
        }


        // Afficher si au moins une médaille
        // est sélectionnée.
        // Sinon masquer le bloc.

        blocks[targetIndex].classList.toggle(
          CSS_CLASS,
          !aUneMedaille
        );

      });
  }


  // ==========================================
  // 11. OPTIMISER LES MISES À JOUR
  // ==========================================

  let scheduled = false;

  function scheduleUpdate() {

    if (scheduled) {
      return;
    }

    scheduled = true;

    requestAnimationFrame(() => {

      scheduled = false;

      update();

    });
  }


  // ==========================================
  // 12. SURVEILLER LES MODIFICATIONS GLOBO
  // ==========================================

  const observer = new MutationObserver(
    (mutations) => {

      const affectsGlobo = mutations.some(
        (mutation) => {

          const node = mutation.target;

          if (
            node.nodeType === 1 &&
            node.closest('.gpo-app')
          ) {
            return true;
          }

          return [
            ...mutation.addedNodes
          ].some((added) =>

            added.nodeType === 1 &&
            (
              added.matches('.gpo-app') ||
              added.querySelector('.gpo-app')
            )

          );
        }
      );

      if (affectsGlobo) {
        scheduleUpdate();
      }
    }
  );


  // ==========================================
  // 13. INITIALISATION
  // ==========================================

  function init() {

    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: [
        'class',
        'style',
        'aria-checked',
        'checked',
        'value'
      ],
    });


    // Écouter les interactions du client
    ['change', 'input', 'click'].forEach(
      (name) => {

        document.addEventListener(
          name,
          (event) => {

            if (
              event.target.closest &&
              event.target.closest('.gpo-app')
            ) {
              scheduleUpdate();
            }

          },
          true
        );
      }
    );


    // Première vérification
    scheduleUpdate();
  }


  // ==========================================
  // 14. LANCEMENT AUTOMATIQUE
  // ==========================================

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );

  } else {

    init();

  }

})();
